import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "@/context/AuthContext";

/** Convenience hook for consuming `AuthContext` with a guarded error message. */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an <AuthProvider>");
  }
  return context;
}

export default useAuth;
